import React, {useContext, useEffect} from 'react';
//import Spinner from '../../comunes/Spinner'
import AlertaContext from '../../../context/alerta/alertaContext';


const SelectorSemana = ({setSemanaSeleccionada, fnSelectorUltSemanas, selectorUltSemanas}) => {
    const alertaContext = useContext(AlertaContext);
    const { alerta/*, mostrarAlerta*/ } = alertaContext;

    
    useEffect(() => {
        if(selectorUltSemanas.length > 0) return;
        fnSelectorUltSemanas();
        //eslint-disable-next-line
    }, [])
    //console.log(usuario.desc_usu_email);
    
    const clickSemanaSeleccionada = (e) => {
        //console.log(parseInt(e, 10));
        setSemanaSeleccionada(parseInt(e, 10));
        //setDatosSemana
        //console.log(JSON.parse(ConsultaLogSemanal.datosSemana));
    }

  return (
    <>
    
        { alerta ?  (<div className={`alerta ${alerta.categoria}`}> {alerta.msg} </div>) : null}
            <div className='row'>
            {/*(loading === true) ? (<div className='spinner'><Spinner/></div>) : null*/}
                <div className='col-sm-12 col-md-12'>
                    <h5 className='card-title'>
                        <div className='form-floating'>
                            <select className='form-control form-control-lg' onChange={e => clickSemanaSeleccionada(e.target.value)}>
                                <option value='0'>-- Seleccione Semana --</option>
                                {(selectorUltSemanas) ?
                                    selectorUltSemanas.map((item) => {
                                        return(
                                            <option key={item.id_tie_semana} value={item.id_tie_semana}>{item.desc_tie_semana}</option>
                                        )
                                    })
                                :null
                                }
                            </select>
                        </div>
                    </h5>
                </div>
            </div>
    </>
  )
}

export default SelectorSemana;